import React, { useRef, useState } from 'react';
import {
  Form,
  FormControl,
  ControlLabel,
  Button,
  ButtonToolbar,
  Panel,
  Icon,
  Whisper,
  Tooltip,
  SelectPicker
} from 'rsuite';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { omitBy, isNull } from 'lodash/fp';
import {
  InlineHelpBlock,
  InlineFormGroup
} from '../../../widgets/FormElements';
import { fetchItemsAndPackagesSkus } from '../../../../redux/Inventory/sagas/reports/items-and-packages-skus/routines';
import {
  resetItemsAndPackagesSkus,
  updateItemsAndPackagesSkusSearchQuery
} from '../../../../redux/Inventory/actions/reports/items-and-packages-skus';
import { getIsFetching } from '../../../../redux/Inventory/selectors/reports/items-and-packages-skus';
import ReportTemplatesModal from '../../../../containers/ReportTemplatesModal';
import { ITEMS_AND_PACKAGES_SKUS } from '../../../../helpers/ReportTemplateTypes';
import {
  ItemType,
  PackageType
} from '../../../../constants/inventory/InventoryTypes';

const StyledFormGroup = styled(InlineFormGroup)`
  margin-bottom: 0 !important;
`;

const TypeOptions = [
  {
    label: 'Item',
    value: ItemType
  },
  {
    label: 'Package',
    value: PackageType
  }
];

export default () => {
  const formRef = useRef();
  const dispatch = useDispatch();
  const [formValue, setFormValue] = useState({});
  const [showPresetModal, setShowPresetModal] = useState(false);

  const isFetching = useSelector(getIsFetching);

  const revalidateForm = () => {
    setTimeout(formRef.current.check, 1);
  };

  const executeSearch = value => {
    const query = omitBy(isNull, value);
    dispatch(fetchItemsAndPackagesSkus(query));
    dispatch(updateItemsAndPackagesSkusSearchQuery(query));
  };

  const handleFormChange = value => {
    setFormValue(value);
  };

  const handleFormSubmit = () => {
    executeSearch(formValue);
  };

  const handleFormReset = () => {
    setFormValue({ itemType: null });
    dispatch(resetItemsAndPackagesSkus());
    dispatch(updateItemsAndPackagesSkusSearchQuery({}));
  };

  const onHidePresetModal = () => {
    setShowPresetModal(false);
  };

  const handleTogglePresetModal = () => {
    const showModal = !showPresetModal;
    setShowPresetModal(showModal);
  };

  const handleSelectTemplate = ({ file: searchQuery }) => {
    onHidePresetModal();
    setFormValue(searchQuery);
    revalidateForm();
    executeSearch(searchQuery);
  };

  const disabledAction = isFetching;

  return (
    <Panel bordered>
      <Form ref={formRef} formValue={formValue} onChange={handleFormChange}>
        <StyledFormGroup>
          <ControlLabel>
            Item Type*
            <InlineHelpBlock tooltip>
              Filter by Item or Package.
            </InlineHelpBlock>
          </ControlLabel>
          <FormControl
            style={{ width: 180 }}
            name="itemType"
            accepter={SelectPicker}
            data={TypeOptions}
          />
        </StyledFormGroup>
        <ButtonToolbar style={{ float: 'right', marginTop: 12 }}>
          <Button
            appearance="primary"
            onClick={handleFormSubmit}
            disabled={disabledAction}
          >
            <Icon icon="search" /> Search
          </Button>
          <Button
            appearance="default"
            onClick={handleFormReset}
            disabled={disabledAction}
          >
            <Icon icon="refresh" /> Reset
          </Button>
          <Whisper
            placement="top"
            trigger="hover"
            speaker={<Tooltip>View Presets</Tooltip>}
          >
            <Button
              appearance="primary"
              color="green"
              onClick={handleTogglePresetModal}
              disabled={disabledAction}
            >
              <Icon icon="list" /> Presets
            </Button>
          </Whisper>
        </ButtonToolbar>
      </Form>
      <ReportTemplatesModal
        show={showPresetModal}
        onHide={onHidePresetModal}
        onSelect={handleSelectTemplate}
        fileType={ITEMS_AND_PACKAGES_SKUS}
      />
    </Panel>
  );
};
